import { render, staticRenderFns } from "./index copy.vue?vue&type=template&id=2c592f72&scoped=true&"
import script from "./index copy.vue?vue&type=script&lang=js&"
export * from "./index copy.vue?vue&type=script&lang=js&"
import style0 from "./index copy.vue?vue&type=style&index=0&id=2c592f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c592f72",
  null
  
)

export default component.exports